import React, { useRef, useState, useContext, useEffect } from 'react';
import { SpikerBoardContext, SpikerBoardContextI } from '../context/SpikerBoardContext';
import { ScrollPanel } from 'primereact/scrollpanel';
import { HPunchType } from '../lib/HPunch';
import axios from 'axios';
import AppConfig from '../AppConfig';
import { HTime, HTimeFormat } from "../lib/HDateTime";
import { HResultStatus } from '../lib/HResult';

export default function SB_FinishLineBox() {
    const [spikerBoardContext, setSpikerBoardContext] = useContext(SpikerBoardContext);
    const c_FinishLinePunchesRef = useRef([]);
    const c_eventStartTime = useRef(null);
    const [c_finishLinePunches, setC_FinishLnePunches] = useState([]);

    useEffect(() => {
        //console.log("FinishLine > on change res");
        parseFinish(spikerBoardContext.c_FinishLinePunchesRef);
    }, [spikerBoardContext.c_FinishLinePunchesRef])
    const parseFinish = (data) => {
        if (spikerBoardContext.c_FinishLinePunchesRef == undefined) return;
        var fl = [];
        data.map((el) => {
            var o = new FinishLineRowInterface();
            o.name = el.Person.Name;
            o.club = el.Person.Club;
            //
            //result
            o.result.time = el.Result.Result;
            o.result.status = el.Result.Status;
            //class
            //console.log(el.Category.Name);
            try {
                o.category.cname = el.Category.Name;

                o.finish.realtime = el.Punch.Realtime;
            } catch (ex) { console.log(ex) }
            fl.push(o);
        });
        setC_FinishLnePunches(fl);
    }/**/
    return (
        <div className="h-full rounded-xl bg-sky-800 flex flex-col">
            <div className="h-8 rounded-xl bg-sky-600 text-center content-center text-white">
                <i className="pi pi-align-right m-2" />
                <h2 className=' text-xl font-bold inline-block'>FINISH LINE</h2>

            </div>
            <div className="flex-1">
                <ScrollPanel className="custombar1 p-2" style={{ height: "100% ", width: "100%" }}>
                    <div className="flex flex-col rounded-xl h-full gap-2 absolute inset-x-0 top-0">
                        {c_finishLinePunches.map((fl) => (
                            <FinishLineRow result={fl} />
                        ))}
                    </div>
                </ScrollPanel>
            </div>
        </div>
    )
}

class FinishLineRowInterface {
    name;
    club;
    category = class {
        id;
        cname;
    }
    result = class {
        time;
        place;
        status;
        timeLoss;
    }
    finish = class {
        realtime;
    }
    start = class {
        realtime;
        time;
    }
}

export function FinishLineRow(props) {
    var rStatus = props.result.result.status;
    rStatus = HResultStatus.NOFF;
    var rTime = HTime.Parse(props.result.result.time);
    var rFinishTime = props.result.finish.realtime;
    var rTimeLoss = props.result.result.timeLoss;
    var rCategory = props.result.category.cname;
    var sh_place = "";
    var sh_time = "";
    var sh_timeLoss = HTime.Parse(rFinishTime).ToString(HTimeFormat.HMS);
    var sh_starttime = props.result.start.realtime;
    var row_bg;
    var text_color = "text-black";
    var text_colors = {
        OK: "text-black",
        NOTOK: "text-black",
        RUN: "text-grey-900"
    }
    var sh_place = "";
    var bg_color = "bg-white";
    var bg_colors = {
        NORMAL: "bg-white",
        RECENT: "bg-green-300"
    }

    return (
        <>
            {(() => {
                if (rStatus == HResultStatus.OK || rStatus == HResultStatus.NOFF) {
                    sh_time = rTime.ToString(HTimeFormat.MMS);
                    if (HTime.Diff(new HTime(), HTime.Parse(rFinishTime)).ToMs() < (10 * 1000)) {
                        bg_color = bg_colors.RECENT;
                    } else {
                        bg_color = bg_colors.NORMAL;
                    }
                } else {
                    sh_time = "DISQ";
                }
            })()}
            <div className={"h-16 grid grid-cols-12 gap-2 " + bg_color + " rounded-xl p-2 mr-6"} >
                <div className="col-span-2">
                    <div className="col-span-12 text-right font-bold">
                        {rCategory}
                    </div>
                    <div className="col-span-12 text-right">
                        {props.result.place}
                    </div>
                </div>
                <div className="col-span-7">
                    <div className="col-span-12 text-left font-bold">
                        {props.result.name}
                    </div>
                    <div className="col-span-12 text-left">
                        {props.result.club}
                    </div>
                </div>
                <div className="col-span-3">
                    <div className="col-span-12 text-right font-bold">
                        {sh_time}
                    </div>
                    <div className="col-span-12 text-right">
                        {sh_timeLoss}
                    </div>
                </div>
            </div >
        </>
    )
}